import { PermissionModel, UserModel} from "../apis";
import { refreshToken, cancelAllRequests } from "../apis/common";
import Vue from "vue";
import Router from "vue-router";
import { Position, Route, RouteConfig } from "vue-router/types/router";
import store from "../store";
import AdminAboutUs from "../views/components/about-us/AdminAboutUs.vue";
import AdminEditAboutUs from "../views/components/about-us/AdminEditAboutUs.vue";
import AdminReviewEditAbout from "../views/components/about-us/AdminReviewEditAbout.vue";
import CheckingLoginSessionPage from "../views/components/CheckingLoginSessionPage.vue";
import MyRouter from '../views/components/common/MyRouter.vue';
import AdminAddNewCustomer from "../views/components/customer-management/AdminAddNewCustomer.vue";
import AdminCustomerDetail from "../views/components/customer-management/AdminCustomerDetail.vue";
import AdminCustomerList from "../views/components/customer-management/AdminCustomerList.vue";
import EquipmentMaintenance from '../views/components/device-management/EquipmentMaintenance.vue';
import Documentation from "../views/components/Documentation.vue";
import Page403 from "../views/components/Page403.vue";
import AdminGroupManagement from "../views/components/groups-management/AdminGroupManagement.vue";
import PerrmissionManagement from "../views/components/groups-management/PerrmissionManagement.vue";
import AddInstruction from "../views/components/instruction-management/AddInstruction.vue";
import AddInstructionReview from "../views/components/instruction-management/AddInstructionReview.vue";
import EditInstruction from "../views/components/instruction-management/EditInstruction.vue";
import Instruction from "../views/components/instruction-management/Instruction.vue";
import InstructionDetail from "../views/components/instruction-management/InstructionDetail.vue";
import AdminLocationDetail from "../views/components/location-management/AdminLocationDetail.vue";
import AdminLocationList from "../views/components/location-management/AdminLocationList.vue";
import MailList from "../views/components/mail-list/MailList.vue";
import AdminHome from "../views/components/overview/AdminHomeRework.vue";
import TreatmentMonitoringDetail from '../views/components/treatment-monitoring/TreatmentMonitoringDetail.vue';
import AddTreatmentRequest from "../views/components/treatment-requests/AddTreatmentRequest.vue";
import AddTreatment from "../views/components/treatments/AddTreatment.vue";
import TreatmentDatabase from "../views/components/treatments/TreatmentDatabase.vue";
import AdminUserManagement from "../views/components/user-management/AdminUserManagement.vue";
import Variable from "../views/components/variable/Variable.vue";
import VariableUnit from "../views/components/variable/VariableUnit.vue";
import WaitingApprovePage from "../views/components/WaitingApprovePage.vue";
import CertificateGraphWrapper from "../views/components/CertificateGraphWrapper.vue";
import FailureTrackingList from '../views/components/failure-tracking/FailureTrackingList.vue';
import FailureTrackingForm from '../views/components/failure-tracking/FailureTrackingForm.vue';
import ShipmentCertificateForm from '../views/components/shipment/ShipmentCertificateForm.vue';
import ActivityLogs from '../views/components/activity-logs/ActivityLogs.vue';
import License from '../views/components/license/License.vue';
import EditLicense from '../views/components/license/EditLicense.vue';
import ReviewLicense from '../views/components/license/ReviewLicense.vue';
import LicenseList from '../views/components/license/LicenseList.vue';
import RPAForm from '../views/components/rpa/RPAForm.vue';
import _ from "lodash";
import RPAManagement from '../views/components/rpa/RPAManagement.vue';
import EditWebConfig from '../views/components/web-config/EditWebConfig.vue';
import i18n from '../locale'; // Internationalization
import Login from '../views/auth/Login.vue';
import ResetPassword from '../views/auth/ResetPassword.vue';
import { ALLOWED_MOBILE_ROUTES, PUBLISH_ROUTES } from '../constants';
import screenService from '../services/ScreenService';
import TheLayoutResponsive from "../views/layout/TheLayoutResponsive.vue";
import TreatmentRequestWrapper from "../views/components/treatment-requests/TreatmentRequestWrapper.vue";
import TreatmentMonitoringWrapper from "../views/components/treatment-monitoring/TreatmentMonitoringWrapper.vue";
import ShipmentCertificateWrapper from '../views/components/shipment/ShipmentCertificateWrapper.vue';
import CertificateWrapper from '../views/components/CetificateWrapper.vue';
import CertificateTreatmentWrapper from '../views/components/CertificateTreatmentWrapper.vue';
import PageNotFound from '../views/components/page-not-found/PageNotFound.vue';
import ForgotPassword from '../views/auth/ForgotPassword.vue';
import ForgotPasswordSuccess from '../views/auth/ForgotPasswordSuccess.vue';
Vue.use(Router);

export const constantRoutes: RouteConfig[] = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/forgot-password-success',
    name: 'forgot-password-success',
    component: ForgotPasswordSuccess
  },
  {
    path: '/page-not-found',
    name: 'page-not-found',
    component: PageNotFound
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: "/403",
    component: TheLayoutResponsive,
    meta: {
      hidden: true,
    },
    children: [
      {
        path: "",
        component: Page403,
        name: "403",
        meta: {
          hidden: true,
        },
      }
    ]
  },
  {
    path: "/",
    redirect: (to) => {
      const isLoggedIn = !!JSON.parse(window.localStorage.getItem("isLoggedIn"));
      return isLoggedIn ? screenService.isMobile() ? '/treatments/requests' : '/home' : '/login';
    }
  },
  {
    path: "/home",
    component: TheLayoutResponsive,
    meta: {},
    children: [
      {
        path: "",
        component: AdminHome,
        name: "home",
        meta: {
          title: "route.home",
          // icon: "mdi-home-variant-outline",
          img: "home.png",
          affix: true,
        },
      },
    ],
  },
  {
    path: "/users",
    component: TheLayoutResponsive,
    name: "users",
    meta: {
      title: "route.user.list",
      img: "users.png",
      breadcrumb: false,
    },
    children: [
      {
        path: "list",
        component: AdminUserManagement,
        name: "user-list",
        meta: {
          context: ["USER_MANAGEMENT"],
          title: "route.user.list",
          roles: ["admin"],
          action: "read"
        },
      },
      {
        path: "groups",
        name: "group",
        component: MyRouter,
        redirect: { name: 'group-list' },
        meta: {
          title: "route.user.groups",
          context: ["GROUP_MANAGEMENT"],
          action: "read"
        },
        children: [
          {
            path: "list",
            name: "group-list",
            component: AdminGroupManagement,
            meta: {
              hidden: true,
              context: ["GROUP_MANAGEMENT"],
              action: "read"
            },
          },
          {
            path: ":id",
            component: PerrmissionManagement,
            name: "group-detail",
            meta: {
              hidden: true,
              context: ["GROUP_MANAGEMENT"],
              action: "read"
            },
          },
        ],
      },
    ],
  },
  {
    path: "/customers",
    component: TheLayoutResponsive,
    name: "customers",
    meta: {
      title: "route.customer.list",
      img: "customers.png",
      breadcrumb: false,
    },
    children: [
      {
        path: "customer",
        component: MyRouter,
        meta: {
          title: "route.customer.list",
          context: ["CUSTOMER_MANAGEMENT"],
          action: "read"
        },
        redirect: () => {
          const me: UserModel = store.getters.user;
          if (me.organization === "CLIENT") {
            return { name: "customer-detail", params: { id: me.customerId }, query: { t: "" + new Date().getTime() } };
          }
          return { name: "customer-list" };
        },
        children: [
          {
            path: "list",
            name: "customer-list",
            component: AdminCustomerList,
            meta: {
              hidden: true,
              context: ["CUSTOMER_MANAGEMENT"],
              action: "read",
              titlePage: "route.customer.list",
            }
          },
          {
            path: "detail/:id",
            component: AdminCustomerDetail,
            name: "customer-detail",
            meta: {
              title: "route.customer.detail",
              hidden: true,
              context: ["CUSTOMER_MANAGEMENT"],
              action: "read",
            },
          },
          {
            path: "edit-customer/:id",
            component: AdminCustomerDetail,
            name: "customer-edit",
            meta: {
              title: "route.customer.edit",
              hidden: true,
              context: ["CUSTOMER_MANAGEMENT"],
              action: "update",
            },
          },
          {
            path: "add-customer",
            component: AdminAddNewCustomer,
            name: "add-customer",
            meta: {
              title: "route.customer.addCustomer",
              hidden: true,
              context: ["CUSTOMER_MANAGEMENT"],
              action: "create",
            },
          },
        ]
      },
      {
        path: "locations",
        component: MyRouter,
        meta: {
          title: "route.customer.locations",
          context: ["LOCATION_MANAGEMENT"],
          action: "read",
        },
        children: [
          {
            path: "",
            name: "locations",
            component: AdminLocationList,
            meta: {
              hidden: true,
              context: ["LOCATION_MANAGEMENT"],
              action: "read",
              titlePage: "route.customer.list",
            },
          },
          {
            path: "location-detail/:id",
            component: MyRouter,
            meta: {
              hidden: true,
              title: "route.customer.locationDetail",
            },
            children: [
              {
                path: "",
                component: AdminLocationDetail,
                name: "location-detail",
                meta: {
                  hidden: true,
                  context: ["LOCATION_MANAGEMENT"],
                  action: "read",
                  titlePage: "route.customer.locationDetail",
                },
              },
              {
                path: "mail-list",
                component: MailList,
                name: "mail-list",
                meta: {
                  title: "route.email.list",
                  hidden: true,
                  context: ["MAILING_LIST_MANAGEMENT"],
                  action: "read",
                },
              },
              {
                path: "variables-plc/:plcId",
                component: Variable,
                name: "variable-plc",
                meta: {
                  hidden: true,
                },
              },
              {
                path: "variable-unit/:unitId",
                component: VariableUnit,
                name: "variable-unit",
                meta: {
                  hidden: true,
                },
              },
            ]
          },
        ]
      },
    ],
  },
  {
    path: "/treatments",
    component: TheLayoutResponsive,
    meta: {
      context: ["TREATMENT_MANAGEMENT"],
      title: "route.treatment.treatments",
      icon: "mdi-hospital-box-outline",
      breadcrumb: false
    },
    children: [
      {
        path: "requests",
        component: MyRouter,
        meta: {
          title: "route.treatment.requests",
        },
        children: [
          {
            path: "",
            name: "treatment-request",
            component: TreatmentRequestWrapper,
            meta: {
              hidden: true,
              titlePage: "route.treatment.requests",
            }
          },
          {
            path: "add-treatment-request",
            component: AddTreatmentRequest,
            name: "add-treatment-request",
            meta: {
              title: "route.treatmentRequest.add",
              hidden: true,
              context: ["TREATMENT_MANAGEMENT"],
              action: "create",
              mode: "NEW",
            },
          },
          {
            path: "edit-treatment-request/:id",
            component: AddTreatmentRequest,
            name: "edit-treatment-request",
            meta: {
              title: "route.treatmentRequest.edit",
              hidden: true,
              context: ["TREATMENT_MANAGEMENT"],
              action: "update",
              mode: "EDIT"
            },
          },
          {
            path: "view-treatment-request/:id",
            component: AddTreatmentRequest,
            name: "view-treatment-request",
            meta: {
              title: "route.treatmentRequest.detail",
              hidden: true,
              context: ["TREATMENT_MANAGEMENT"],
              mode: "VIEW",
            },
          },
        ]
      },
      {
        path: "database",
        component: MyRouter,
        meta: {
          context: ["TREATMENT_DATABASE_MANAGEMENT"],
          title: "route.treatment.database",
        },
        children: [
          {
            path: "",
            component: TreatmentDatabase,
            name: "database",
            meta: {
              hidden: true,
              context: ["TREATMENT_DATABASE_MANAGEMENT"],
              action: "read",
              titlePage: "route.treatment.database",
            }
          },
          {
            path: "add-treatment",
            component: AddTreatment,
            name: "add-treatment",
            meta: {
              title: "route.treatment.add",
              hidden: true,
              mode: "NEW",
              action: "create",
              context: ["TREATMENT_DATABASE_MANAGEMENT"],
            },
          },
          {
            path: "edit-treatment/:id",
            component: AddTreatment,
            name: "edit-treatment",
            meta: {
              title: "route.treatment.edit",
              hidden: true,
              mode: "EDIT",
              action: "update",
              context: ["TREATMENT_DATABASE_MANAGEMENT"],
            },
          },
          {
            path: "view-treatment/:id",
            component: AddTreatment,
            name: "treatment-detail",
            meta: {
              title: "route.treatment.detail",
              hidden: true,
              mode: "VIEW",
              action: "read",
              context: ["TREATMENT_DATABASE_MANAGEMENT"],
            },
          },
        ]
      },
      {
        path: "monitoring",
        component: MyRouter,
        meta: {
          title: "route.treatment.monitoring",
        },
        children: [
          {
            path: "",
            component: TreatmentMonitoringWrapper,
            name: "monitoring",
            meta: {
              hidden: true,
              titlePage: "route.treatment.monitoring",
            }
          },
          {
            path: ":id",
            component: TreatmentMonitoringDetail,
            name: "monitoring-detail",
            meta: {
              title: "route.treatment.monitoring_detail",
              hidden: true,
            },
          },
        ]
      },
      {
        path: "failure-tracking",
        component: MyRouter,
        meta: {
          title: "route.treatment.failure_tracking",
          context: ["FAILURE_TRACKING_MANAGEMENT"],
          action: "read",
        },
        children: [
          {
            path: "",
            name: "failure-tracking",
            component: FailureTrackingList,
            meta: {
              hidden: true,
              context: ["FAILURE_TRACKING_MANAGEMENT"],
              action: "read",
              titlePage: "route.treatment.failure_tracking",
            }
          },
          {
            path: "add-failure-tracking",
            props: {
              action: "NEW",
            },
            component: FailureTrackingForm,
            name: "add-failure-tracking",
            meta: {
              title: "route.failureTracking.add",
              hidden: true,
              context: ["FAILURE_TRACKING_MANAGEMENT"],
              action: "create",
            },
          },
          {
            path: "edit-failure-tracking/:id",
            props: {
              action: "EDIT",
            },
            component: FailureTrackingForm,
            name: "edit-failure-tracking",
            meta: {
              title: "route.failureTracking.edit",
              hidden: true,
              context: ["FAILURE_TRACKING_MANAGEMENT"],
              action: "update",
            },
          },
          {
            path: "view-failure-tracking/:id",
            component: FailureTrackingForm,
            name: "view-failure-tracking",
            props: {
              action: "VIEW",
            },
            meta: {
              title: "route.failureTracking.detail",
              hidden: true,
              context: ["FAILURE_TRACKING_MANAGEMENT"],
              action: "read",
            },
          },
        ]
      },
      {
        path: "shipment",
        component: MyRouter,
        meta: {
          title: "route.treatment.shipment_certificates",
        },
        children: [
          {
            path: "",
            component: ShipmentCertificateWrapper,
            name: "shipment",
            meta: {
              hidden: true,
              context: ["SHIPMENT_CERTIFICATE_REPORTS"],
              action: "read",
              titlePage: "route.treatment.shipment_certificates",
            },
          },
          {
            path: "shipment-detail/:id",
            component: ShipmentCertificateForm,
            name: "shipment-detail",
            meta: {
              hidden: true,
              title: "route.shipment.detail",
              mode: "VIEW",
              context: ["SHIPMENT_CERTIFICATE_REPORTS"],
              action: "read",
            },
          },
          {
            path: "add-shipment",
            component: ShipmentCertificateForm,
            name: "add-shipment",
            meta: {
              hidden: true,
              title: "route.shipment.add",
              mode: "ADD",
              context: ["SHIPMENT_CERTIFICATE_REPORTS"],
              action: "create",
            },
          },
          {
            path: "edit-shipment/:id",
            component: ShipmentCertificateForm,
            name: "edit-shipment",
            meta: {
              hidden: true,
              title: "route.shipment.edit",
              mode: "EDIT",
              context: ["SHIPMENT_CERTIFICATE_REPORTS"],
              action: "update",
            },
          },
        ]
      },

      {
        path: "rpa",
        component: MyRouter,
        meta: {
          title: "route.treatment.rpa",
          context: ["RPA_MANAGEMENT"],
          action: "read",
        },
        children: [
          {
            path: "",
            component: RPAManagement,
            name: "rpa",
            meta: {
              titlePage: "route.treatment.rpa",
              hidden: true,
              context: ["RPA_MANAGEMENT"],
              action: "read",
            },
          },
          {
            path: "add-rpa",
            component: RPAForm,
            name: "add-rpa",
            meta: {
              hidden: true,
              title: "route.rpa.add",
              mode: "ADD",
              context: ["RPA_MANAGEMENT"],
              action: "create",
            },
          },
          {
            path: "detail-rpa/:id",
            component: RPAForm,
            name: "detail-rpa",
            meta: {
              hidden: true,
              title: "route.rpa.view",
              mode: "VIEW",
              context: ["RPA_MANAGEMENT"],
              action: "read",
            },
          },
          {
            path: "edit-rpa/:id",
            component: RPAForm,
            name: "edit-rpa",
            meta: {
              hidden: true,
              title: "route.rpa.edit",
              mode: "EDIT",
              context: ["RPA_MANAGEMENT"],
              action: "update",
            },
          },
        ]
      },
    ],
  },
  {
    path: "/maintenance-equipment",
    component: TheLayoutResponsive,
    meta: {
      title: "route.content.maintenance_equipment",
      context: ["MAINTENANCE_TRACKING_MANAGEMENT"],
      action: "read",
      img: "maintenance.png",
      breadcrumb: false
    },
    children: [
      {
        path: "",
        name: "equipment",
        component: EquipmentMaintenance,
        meta: {
          hidden: true,
          context: ["MAINTENANCE_TRACKING_MANAGEMENT"],
          action: "read",
          titlePage: "route.content.maintenance_equipment",
        }
      }
    ]
  },
  {
    path: "/contents",
    component: TheLayoutResponsive,
    meta: {
      title: "route.content.contents",
      img: "contents.png",
      breadcrumb: false
    },
    children: [
      {
        path: "activity-logs",
        component: ActivityLogs,
        name: "activity-logs",
        meta: {
          title: "route.content.activity_logs",
        },
      },
      {
        path: "license-list",
        component: LicenseList,
        name: "license-list",
        meta: {
          title: "route.content.license_list",
          context: ["LICENSE_LIST"],
          action: "read"
        },
      },
      {
        path: "instructions",
        component: MyRouter,
        meta: {
          title: "route.content.instructions",
        },
        children: [
          {
            path: "",
            name: "instructions",
            component: Instruction,
            meta: {
              hidden: true,
              context: ["OPERATION_INSTRUCTION"],
              action: "read",
              roles: ["admin"],
              titlePage: "route.content.instructions",
            },
          },
          {
            path: "instruction-detail/:id",
            component: InstructionDetail,
            name: "instruction-detail",
            meta: {
              hidden: true,
              context: ["OPERATION_INSTRUCTION"],
              action: "read",
              title: "route.instruction.instruction_detail",
              roles: ["admin"],
            },
          },
          {
            path: "edit-instruction/:id",
            component: EditInstruction,
            name: "edit-instruction",
            meta: {
              hidden: true,
              context: ["OPERATION_INSTRUCTION"],
              action: "update",
              title: "route.instruction.edit_instruction",
              roles: ["admin"],
            },
          },
          {
            path: "review-instruction",
            component: AddInstructionReview,
            name: "review-instruction",
            meta: {
              hidden: true,
              context: ["OPERATION_INSTRUCTION"],
              action: "read",
              title: "route.instruction.review_instruction",
              roles: ["admin"],
            },
          },
          {
            path: "add-instruction",
            component: AddInstruction,
            name: "add-instruction",
            meta: {
              hidden: true,
              context: ["OPERATION_INSTRUCTION"],
              action: "create",
              title: "route.instruction.add_instruction",
              roles: ["admin"],
            },
          },
        ],
      },
      {
        path: "web-config",
        component: EditWebConfig,
        name: "edit-webconfig",
        meta: {
          title: "route.content.web_config",
          context: ["WEB_CONFIG"],
          action: "read"
        },
      }
    ],
  },
  {
    path: "/support",
    component: TheLayoutResponsive,
    meta: {
      title: "route.support.support",
      img: "support.png",
      breadcrumb: false,
      alwaysShow: true
    },
    children: [
      // {
      //   path: "support",
      //   name: "support",
      //   component: Documentation,
      //   meta: {
      //     title: "route.support.support",
      //   },
      // },
      {
        path: "info",
        component: MyRouter,
        name: "info",
        meta: {
          title: "route.support.info",
          breadcrumb: false
        },
        redirect: {
          name: "about"
        },
        children: [
          {
            path: "about",
            component: MyRouter,
            meta: {
              title: "route.about.abouts",
              hidden: true,
            },
            children: [
              {
                path: "",
                name: "about",
                component: AdminAboutUs,
                meta: {
                  hidden: true,
                  context: ["ABOUT_PAGE"],
                  titlePage: "route.about.abouts",
                },
              },
              {
                path: "edit",
                component: MyRouter,
                meta: {
                  title: "route.about.editAbout",
                  hidden: true,
                },
                children: [
                  {
                    path: "",
                    component: AdminEditAboutUs,
                    name: "edit-about",
                    meta: {
                      hidden: true,
                      context: ["ABOUT_PAGE"],
                      titlePage: "route.about.editAbout",
                    }
                  },
                  {
                    path: "review",
                    component: AdminReviewEditAbout,
                    name: "review-edit-about",
                    meta: {
                      context: ["ABOUT_PAGE"],
                      title: "route.about.reviewEditAbout",
                      hidden: true,
                    }
                  }
                ]
              },
            ]
          },
        ]
      },
       {
        path: "license",
        component: MyRouter,
        meta: {
          title: "route.support.license",
          context: ["LICENSE"],
        },
        children: [
          {
            path: "",
            component: License,
            name: "license",
            meta: {
              hidden: true,
              context: ["LICENSE"],
              action: "read",
              titlePage: "route.support.license",
            }
          },
          {
            path: "edit-license",
            component: MyRouter,
            meta: {
              hidden: true,
              title: "route.license.edit",
            },
            children: [
              {
                path: "",
                component: EditLicense,
                name: "edit-license",
                meta: {
                  hidden: true,
                  context: ["LICENSE"],
                  action: "update",
                  titlePage: "route.license.edit",
                },
              },
              {
                path: "review-license",
                component: ReviewLicense,
                name: "review-license",
                meta: {
                  hidden: true,
                  title: "route.license.review",
                  context: ["LICENSE"],
                  action: "update"
                }
              },
            ]
          },
        ]
      },
    ],
  },
  // {
  //   path: "/configs",
  //   component: Layout,
  //   meta: {
  //     title: "route.configs",
  //     img: "config.png",
  //   },
  //   children: [
  //     {
  //       path: "mail",
  //       component: Documentation,
  //       name: "mail",
  //       meta: {
  //         title: "route.config.mail",
  //       },
  //     },
  //     {
  //       path: "password",
  //       component: Documentation,
  //       name: "password",
  //       meta: {
  //         title: "route.config.password",
  //       },
  //     },
  //     {
  //       path: "notification",
  //       component: Documentation,
  //       name: "notification",
  //       meta: {
  //         title: "route.config.notification",
  //       },
  //     },
  //   ],
  // },
  {
    path: "/waiting-approve",
    component: WaitingApprovePage,
    name: "waiting-approve",
    meta: {
      hidden: true,
    },
  },
  {
    path: "/certificate/:id",
    name: "certificate-export",
    component: CertificateWrapper,
    meta: {
      hidden: true,
      context: ["SHIPMENT_CERTIFICATE_REPORTS"],
      action: "read",
      titlePage: "route.treatment.shipment_certificates",
    },
  },
  // {
  //   path: "/certificate/:id",
  //   name: "certificate-export",
  //   component: Certificate,
  //   meta: {
  //     hidden: true,
  //     context: ["SHIPMENT_CERTIFICATE_REPORTS"],
  //     action: "read",
  //     titlePage: "route.treatment.shipment_certificates",
  //   },
  // },
  {
    path: "/certificate-treatment/:id",
    name: "certificate-treatment",
    component: CertificateTreatmentWrapper,
    meta: {
      hidden: true,
      context: ["TREATMENT_MANAGEMENT|VIEW_CERTIFICATE"],
      action: "read",
      titlePage: "route.certificates.treatment_certificate",
    },
  },
  {
    path: "/certificate-graph/:id",
    name: "certificate-graph",
    component: CertificateGraphWrapper,
    meta: {
      hidden: true,
      titlePage: "route.certificates.graph_certificate",
    },
  },
];

const router = new Router({
  // mode: 'history', // gh-pages
  scrollBehavior: () => ({ y: 0 } as Position),
  routes: constantRoutes,
});

router.beforeEach(async (to: Route, from: Route, next) => {

  const DEFAULT_TITLE = 'EcO2 Treatment';

  Vue.nextTick(() => {
    if (to.meta.title) {
      if (!['route.treatment.monitoring_detail'].includes(to.meta.title)){
        document.title = i18n.t(to.meta.title).toString();
      }
    } else {
      document.title = i18n.t(to.meta.titlePage).toString() || DEFAULT_TITLE;
    }
  });
  // Routes without login
  const authRequired = !PUBLISH_ROUTES.includes(to.name);
  const isLoggedIn = !!JSON.parse(window.localStorage.getItem("isLoggedIn"));
  if (isLoggedIn && to.name === 'login') {
    return next({ name: 'home' });
  }
  if (!isLoggedIn && authRequired) {
    if (to.name !== 'login') {
      return next({ name: 'login' });
    } else {
      return next();
    }
  }
  if (screenService.isMobile() && to.name && !ALLOWED_MOBILE_ROUTES.includes(to.name)) {
    next({ name: "page-not-found" });
  }
  const { context, action } = to.meta;
  const permissions: PermissionModel[] = store.getters.permissions;
  if (!_.isEmpty(context) && !_.isEmpty(action) && !_.isEmpty(permissions)) {
    const p = permissions.find(val => val.code === context[0] && val.action.indexOf(action) !== -1);
    if (!p) {
      next({ name: "403" });
    }
  }
  store.commit("ROUTE_START");
  if (from.name && to.name && !_.isEqual(from.name, to.name)) {
    cancelAllRequests();
    refreshToken();
  }
  next();
  store.commit("ROUTE_END");
});
router.afterEach(async () => {
  store.commit("ROUTE_END");
});

export default router;

export const asyncRoutes = [
  /** When your routing table is too long, you can split it into small modules */
  // permissionRouter,
  // vuetifyRouter,
  // ...componentsRouter,
  // nestedRouter,
  // errorsRouter,
  { path: "*", redirect: "/error/404", hidden: true },
];
